import {
  FeatureGroup, MapContainer, Marker, Popup, TileLayer,
} from 'react-leaflet';
import 'leaflet-defaulticon-compatibility';
import { useEffect, useRef } from 'react';

export default function PartnerAreaMap({ team }) {
  const map = useRef(null);
  const groupRef = useRef(null);

  const latLng = [team.basements[0] ? team.basements[0].lat : team.lat, team.basements[0] ? team.basements[0].lng : team.lng];

  useEffect(() => {
    setTimeout(() => {
      if (groupRef.current) {
        const group = groupRef.current; // get native featureGroup instance
        map.current.fitBounds(group.getBounds());
      }
    }, 500);
  }, []);

  return team.lat && team.lng && (
    <div className="w-full h-full overflow-hidden">
      <MapContainer
        center={latLng}
        zoom={9}
        ref={map}
        scrollWheelZoom={false}
        style={{ height: '100%', width: '100%' }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <FeatureGroup ref={groupRef}>
          {team.basements.map((b) => (
            <Marker position={[b.lat, b.lng]} key={b.id}>
              <Popup>
                {b.name}
              </Popup>
            </Marker>
          ))}
        </FeatureGroup>
      </MapContainer>
    </div>
  );
}
